import React, { createContext, useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import Cookies from 'js-cookie';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {

  const [isAuthenticated, setIsAuthenticated] = useState(
    () => Cookies.get("isAuthenticated") === "true"
  );

  const authenticate = () => {
    setIsAuthenticated(true);
    Cookies.set("isAuthenticated", "true", { expires: 5 });
  };

  const [token, setToken] = useState(() => Cookies.get("token") || null);

  const [user, setUser] = useState(() => {
    const userData = Cookies.get("user");
    return userData ? JSON.parse(userData) : null;
  });

  const [RecentUser, setRecentUser] = useState(() => Cookies.get("RecentUser") || null);

  const [recentQuizz, setRecentQuizz] = useState(() => {
    const quizzData = Cookies.get("recentQuizz");
    return quizzData ? JSON.parse(quizzData) : null;
  });
  
  const siteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY;
  const [quizPaymentValidated, setQuizPaymentValidated] = useState(
    () => Cookies.get("quizPaymentValidated") === "true"
  );

  const saveToken = (token) => {
    setToken(token);
    Cookies.set("token", token, { expires: 7 }); // Expires in 7 days
  };

  const validateQuizPayment = () => {
    setQuizPaymentValidated(true);
    Cookies.set("quizPaymentValidated", "true", { expires: 7 }); // Expires in 7 days
  };

  const saveUser = (infos) => {
    setUser(infos);
    Cookies.set("user", JSON.stringify(infos), { expires: 7 }); // Expires in 7 days
  };

  const saveRecentQuizz = (quizzData) => {
    setRecentQuizz(quizzData);
    Cookies.set("recentQuizz", JSON.stringify(quizzData), { expires: 7 }); // Expires in 7 days
  };

  const setRecentquizzToNull = () => {
    setRecentQuizz(null);
  };

  const saveRecentUser = (infos) => {
    setRecentUser(infos);
    Cookies.set("RecentUser", infos, { expires: 7 }); // Expires in 7 days
  };

  const signOut = () => {
    setIsAuthenticated(false);
    Cookies.remove("isAuthenticated");
    Cookies.remove("token");
    Cookies.remove("user");
    Cookies.remove("recentQuizz");
    Cookies.remove("quizPaymentValidated");
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setIsAuthenticated(Cookies.get("isAuthenticated") === "true");
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    if (user === null) {
      const storedUser = Cookies.get("user");
      
      if (storedUser && typeof storedUser === 'string') {
        try {
          const parsedUser = JSON.parse(storedUser);
          setUser(parsedUser);
        } catch (error) {
          console.error('Error parsing JSON from storedUser:', error);
        }
      } else {
        console.error('No valid storedUser found or storedUser is not a string.');
      }
    }
  }, [user]);
  
const { t } = useTranslation();
const questions = [
  {
    id: 1,
    text: t("Personal Background: What is your nationality?"),
    questionType: "dropdownCounty",
    choices: [
      t("Afghanistan"),
      t("Albania"),
      t("Algeria"),
      t("Andorra"),
      t("Angola"),
      t("Antigua and Barbuda"),
      t("Argentina"),
      t("Armenia"),
      t("Australia"),
      t("Austria"),
      t("Azerbaijan"),
      t("Bahamas"),
      t("Bahrain"),
      t("Bangladesh"),
      t("Barbados"),
      t("Belarus"),
      t("Belgium"),
      t("Belize"),
      t("Benin"),
      t("Bhutan"),
      t("Bolivia"),
      t("Bosnia and Herzegovina"),
      t("Botswana"),
      t("Brazil"),
      t("Brunei"),
      t("Bulgaria"),
      t("Burkina Faso"),
      t("Burundi"),
      t("Côte d'Ivoire"),
      t("Cabo Verde"),
      t("Cambodia"),
      t("Cameroon"),
      t("Canada"),
      t("Central African Republic"),
      t("Chad"),
      t("Chile"),
      t("China"),
      t("Colombia"),
      t("Comoros"),
      t("Congo (Congo-Brazzaville)"),
      t("Costa Rica"),
      t("Croatia"),
      t("Cuba"),
      t("Cyprus"),
      t("Czechia (Czech Republic)"),
      t("Democratic Republic of the Congo"),
      t("Denmark"),
      t("Djibouti"),
      t("Dominica"),
      t("Dominican Republic"),
      t("Ecuador"),
      t("Egypt"),
      t("El Salvador"),
      t("Equatorial Guinea"),
      t("Eritrea"),
      t("Estonia"),
      t("Eswatini"),
      t("Ethiopia"),
      t("Fiji"),
      t("Finland"),
      t("France"),
      t("Gabon"),
      t("Gambia"),
      t("Georgia"),
      t("Germany"),
      t("Ghana"),
      t("Greece"),
      t("Grenada"),
      t("Guatemala"),
      t("Guinea"),
      t("Guinea-Bissau"),
      t("Guyana"),
      t("Haiti"),
      t("Holy See"),
      t("Honduras"),
      t("Hungary"),
      t("Iceland"),
      t("India"),
      t("Indonesia"),
      t("Iran"),
      t("Iraq"),
      t("Ireland"),
      t("Israel"),
      t("Italy"),
      t("Jamaica"),
      t("Japan"),
      t("Jordan"),
      t("Kazakhstan"),
      t("Kenya"),
      t("Kiribati"),
      t("Kuwait"),
      t("Kyrgyzstan"),
      t("Laos"),
      t("Latvia"),
      t("Lebanon"),
      t("Lesotho"),
      t("Liberia"),
      t("Libya"),
      t("Liechtenstein"),
      t("Lithuania"),
      t("Luxembourg"),
      t("Madagascar"),
      t("Malawi"),
      t("Malaysia"),
      t("Maldives"),
      t("Mali"),
      t("Malta"),
      t("Marshall Islands"),
      t("Mauritania"),
      t("Mauritius"),
      t("Mexico"),
      t("Micronesia"),
      t("Moldova"),
      t("Monaco"),
      t("Mongolia"),
      t("Montenegro"),
      t("Morocco"),
      t("Mozambique"),
      t("Myanmar (formerly Burma)"),
      t("Namibia"),
      t("Nauru"),
      t("Nepal"),
      t("Netherlands"),
      t("New Zealand"),
      t("Nicaragua"),
      t("Niger"),
      t("Nigeria"),
      t("North Korea"),
      t("North Macedonia (formerly Macedonia)"),
      t("Norway"),
      t("Oman"),
      t("Pakistan"),
      t("Palau"),
      t("Palestine State"),
      t("Panama"),
      t("Papua New Guinea"),
      t("Paraguay"),
      t("Peru"),
      t("Philippines"),
      t("Poland"),
      t("Portugal"),
      t("Qatar"),
      t("Romania"),
      t("Russia"),
      t("Rwanda"),
      t("Saint Kitts and Nevis"),
      t("Saint Lucia"),
      t("Saint Vincent and the Grenadines"),
      t("Samoa"),
      t("San Marino"),
      t("Sao Tome and Principe"),
      t("Saudi Arabia"),
      t("Senegal"),
      t("Serbia"),
      t("Seychelles"),
      t("Sierra Leone"),
      t("Singapore"),
      t("Slovakia"),
      t("Slovenia"),
      t("Solomon Islands"),
      t("Somalia"),
      t("South Africa"),
      t("South Korea"),
      t("South Sudan"),
      t("Spain"),
      t("Sri Lanka"),
      t("Sudan"),
      t("Suriname"),
      t("Sweden"),
      t("Switzerland"),
      t("Syria"),
      t("Tajikistan"),
      t("Tanzania"),
      t("Thailand"),
      t("Timor-Leste"),
      t("Togo"),
      t("Tonga"),
      t("Trinidad and Tobago"),
      t("Tunisia"),
      t("Turkey"),
      t("Turkmenistan"),
      t("Tuvalu"),
      t("Uganda"),
      t("Ukraine"),
      t("United Arab Emirates"),
      t("United Kingdom"),
      t("United States of America"),
      t("Uruguay"),
      t("Uzbekistan"),
      t("Vanuatu"),
      t("Venezuela"),
      t("Vietnam"),
      t("Yemen"),
      t("Zambia"),
      t("Zimbabwe"),
    ],
  },

  {
    id: 2,

    text: t(
      "2.	Relationship Status: What is your current relationship status?"
    ),

    questionType: "checkbox",

    choices: [
      t("Single"),
      t("Dating"),
      t("Engaged"),
      t("Married"),
      t("Divorced"),
      t("Widowed"),
    ],
    suggestionMapping: {
      Single: { score: 3, suggestion: "A" },
      Dating: { score: 1, suggestion: "B" },
      Engaged: { score: 1, suggestion: "B" },
      Married: { score: 1, suggestion: "B" },
      Divorced: { score: 1, suggestion: "B" },
      Widowed: { score: 1, suggestion: "B" },
    },
    SentenceMapping: {
      Single: "sentence 1",
      Dating: "sentence 2",
      Engaged: "sentence 3",
      Married:"sentence 4",
      Divorced: "sentence 5",
      Widowed:"sentence 6",
    },
  },

  {
    id: 3,

    text: t("Family Planning: Do you currently have children from previous relationships?"),

    questionType: "checkbox",

    choices: [t("Yes"), t("No")],

    suggestionMapping: {
      Yes: { score: 1, suggestion: "A" },

      No: { score: 1, suggestion: "B" },
    },
    SentenceMapping: {
      Yes: "sentence 1",
      No: "sentence 2",
    },
  },

  {
    id: 4,

    text: t(
      "Length of Relationship: How long have you been together as a couple?"
    ),

    questionType: "checkbox",

    choices: [
      t("Less than 6 months"),
      t("6 months to 1 year"),
      t("1 to 3 years"),
      t("3 to 5 years"),
      t("More than 5 years"),
    ],
    suggestionMapping: {
      "Less than 6 months": { score: 3, suggestion: "A" },
      "6 months to 1 year": { score: 1, suggestion: "B" },
      "1 to 3 years": { score: 1, suggestion: "B" },
      "3 to 5 years": { score: 1, suggestion: "B" },
      "More than 5 years": { score: 1, suggestion: "B" },
    },
    SentenceMapping: {
      "Less than 6 months": "sentence 1",
      "6 months to 1 year": "sentence 2",
      "1 to 3 years": "sentence 3",
      "3 to 5 years":"sentence 4",
      "More than 5 years": "sentence 5",
    },
  },

  {
    id: 5,

    text: t(
      "Financial Independence: Are you currently financially independent?"
    ),

    questionType: "checkbox",

    choices: [t("Yes"), t("No")],

    suggestionMapping: {
      Yes: { score: 4, suggestion: "B" },

      No: { score: 3, suggestion: "A" },
    },
    SentenceMapping: {
      Yes: "sentence 1",
      No: "sentence 2",
    },
  },

  {
    id: 6,

    text: t(
      "If yes to the previous question, on a scale of 1 to 5, how important is having individual financial autonomy within your relationship?"
    ),

    questionType: "checkbox",

    choices: [
      t("Not important, prioritizing shared financial goals"),

      t("Somewhat important, recognizing the importance of shared goals."),

      t("Moderately important, desiring some individual financial freedom."),

      t(
        "Quite important, emphasizing the maintenance of financial independence."
      ),

      t(
        "Very important, placing a high value on individual financial autonomy."
      ),
    ],

    suggestionMapping: {
      "Not important, prioritizing shared financial goals": {
        score: 4,
        suggestion: "B",
      },
      "Somewhat important, recognizing the importance of shared goals.": {
        score: 3,
        suggestion: "B",
      },
      "Moderately important, desiring some individual financial freedom.": {
        score: 2,
        suggestion: "A",
      },
      "Quite important, emphasizing the maintenance of financial independence.":
        { score: 3, suggestion: "A" },
      "Very important, placing a high value on individual financial autonomy.":
        { score: 4, suggestion: "A" },
    },
    SentenceMapping: {
      "Not important, prioritizing shared financial goals": "sentence 1",
      "Somewhat important, recognizing the importance of shared goals.": "sentence 2",
      "Moderately important, desiring some individual financial freedom.": "sentence 3",
      "Quite important, emphasizing the maintenance of financial independence.":"sentence 4",
      "Very important, placing a high value on individual financial autonomy.": "sentence 5",
    },
  },

  {
    id: 7,
    text: t(
      "Income Disparity: How would you describe the difference in income between you and your partner?"
    ),
    questionType: "checkbox",
    choices: [
      t("Similar income levels"),
      t("Slight income difference"),
      t("Moderate income difference"),
      t("Significant income difference"),
    ],
    suggestionMapping: {
      "Similar income levels": { score: 2, suggestion: "B" },
      "Slight income difference": { score: 1, suggestion: "B" },
      "Moderate income difference": { score: 1, suggestion: "A" },
      "Significant income difference": { score: 2, suggestion: "A" },
    },
    SentenceMapping: {
      "Similar income levels": "sentence 1",
      "Slight income difference": "sentence 2",
      "Moderate income difference": "sentence 3",
      "Significant income difference":"sentence 4",
    },
  },

  
  {
    id: 8,
    text: t(
      "Your Debt Status: Do you currently have any debt, and if so, what is the amount?"
    ),
    questionType: "checkbox",
    choices: [
      t("I have $0 in debt."),
      "$0-10,000",
      "$10,001-100,000",
      "$100,001+",
    ],
    suggestionMapping: {
      "I have $0 in debt.": { score: 3, suggestion: "B" },
      "$0-10,000": { score: 1, suggestion: "B" },
      "$10,001-100,000": { score: 3, suggestion: "A" },
      "$100,001+": { score: 4, suggestion: "A" },
    },
    SentenceMapping: {
      "I have $0 in debt.": "sentence 1",
      "$0-10,000": "sentence 2",
      "$10,001-100,000": "sentence 3",
      "$100,001+":"sentence 4",
    },
  },

  {
    id: 9,
    text: t(
      "Regarding joint debts like mortgages or car loans, what is your preference?"
    ),
    questionType: "checkbox",
    choices: [
      t("Embracing joint financial commitments"),
      t("Preferring individual responsibility for debts"),
      t("Reserving joint debts for significant expenditures"),
    ],
    suggestionMapping: {
      "Embracing joint financial commitments": { score: 10, suggestion: "B" },
      "Preferring individual responsibility for debts": {
        score: 5,
        suggestion: "B",
      },
      "Reserving joint debts for significant expenditures": {
        score: 4,
        suggestion: "B",
      },
    },
    SentenceMapping: {
      "Embracing joint financial commitments": "sentence 1",
      "Preferring individual responsibility for debts": "sentence 2",
      "Reserving joint debts for significant expenditures": "sentence 3",
    },
  },

  {
    id: 10,
    text: t(
      "Money Impact: Describe how you anticipate money might impact your relationship, either positively or negatively."
    ),
    questionType: "checkbox",
    choices: [
      t("Positively"),
      t("Negatively"),
      t("None"),
    ],
    suggestionMapping: {
      "Positively": { score: 10, suggestion: "B" },
      "Negatively": {
        score: 5,
        suggestion: "B",
      },
      "None": {
        score: 4,
        suggestion: "B",
      },
    },
    SentenceMapping: {
      "Positively": "sentence 1",
      "Negatively": "sentence 2",
      "None": "sentence 3",
    },
  },

  {
    id: 11,

    text: t(
      "Do you prefer a more amicable and cost-effective process in the event of a divorce?"
    ),

    questionType: "checkbox",

    choices: [t("Yes"), t("No")],

    suggestionMapping: {
      Yes: { score: 4, suggestion: "B" },

      No: { score: 3, suggestion: "A" },
    },
    SentenceMapping: {
      Yes: "sentence 1",
      No: "sentence 2",
    },
  },

  {
    id: 12,
    text: t(
      "How would you describe your approach to financial planning?"
    ),
    questionType: "checkbox",
    choices: [
      t("I prefer detailed budgeting."),
      t("I prefer a flexible approach."),
      t("I don't engage in budgeting."),
    ],
    suggestionMapping: {
      "I prefer detailed budgeting.": { score: 10, suggestion: "B" },
      "I prefer a flexible approach.": {
        score: 5,
        suggestion: "B",
      },
      "I don't engage in budgeting.": {
        score: 4,
        suggestion: "B",
      },
    },
    SentenceMapping: {
      "I prefer detailed budgeting.": "sentence 1",
      "I prefer a flexible approach.": "sentence 2",
      "I don't engage in budgeting.": "sentence 3",
    },
  },

  {
    id: 13,
    text: t(
      "Financial Transparency: Assess your comfort level with sharing financial details."
    ),
    questionType: "checkbox",
    choices: [
      t("Fully comfortable sharing all financial details."),
      t("Comfortable with general information but value some privacy."),
      t("Preferring to keep most financial details private."),
    ],
    suggestionMapping: {
      "Fully comfortable sharing all financial details.": { score: 10, suggestion: "B" },
      "Comfortable with general information but value some privacy.": {
        score: 5,
        suggestion: "B",
      },
      "Preferring to keep most financial details private.": {
        score: 4,
        suggestion: "B",
      },
    },
    SentenceMapping: {
      "Fully comfortable sharing all financial details.": "sentence 1",
      "Comfortable with general information but value some privacy.": "sentence 2",
      "Preferring to keep most financial details private": "sentence 3",
    },
  },
];

  return (
    <AppContext.Provider
      value={{
        isAuthenticated,
        authenticate,
        signOut,
        token,
        saveToken,
        user,
        saveUser,
        RecentUser,
        saveRecentUser,
        recentQuizz,
        saveRecentQuizz,questions,
        setRecentquizzToNull,
        validateQuizPayment,
        quizPaymentValidated,
        siteKey,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
